// The window every Help link opens in, so a second link reuses it instead of piling up tabs.
export const HELP_WINDOW = 'bestnotes-help';

/**
 * Opens the Help app (#6453; client/help, guides from api/help through the Help API) in its own
 * window, or one guide in it, e.g. '/help/#/contacts/add-a-client'. Reuses the Help window.
 */
export function openHelp(url = '/help/') {
    window.open(url, HELP_WINDOW)?.focus();
}
